// ============== MAILSTORE DESIGN SYSTEM (Style 1) ==============
// Clean Dark Navy-Gold theme
// Fonts: Be Vietnam Pro + JetBrains Mono (loaded via app.scss)

export const colors = {
  bg: '#0A0E1A',
  bgCard: '#111827',
  bgCardHover: '#1a2235',
  surface: '#1E293B',
  surfaceLight: '#2a3a52',
  border: '#1e3a5f',
  borderLight: '#2d4a6f',
  text: '#E2E8F0',
  muted: '#94A3B8',
  dim: '#64748B',
  accent: '#22c55e',
  accentHover: '#4ade80',
  accentDim: 'rgba(34,197,94,0.15)',
  accentGlow: 'rgba(34,197,94,0.3)',
  success: '#10B981',
  successDim: 'rgba(16,185,129,0.15)',
  danger: '#EF4444',
  dangerDim: 'rgba(239,68,68,0.12)',
  info: '#3B82F6',
  infoDim: 'rgba(59,130,246,0.12)',
  purple: '#8B5CF6',
  purpleDim: 'rgba(139,92,246,0.12)',
  grad: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)',
};

export const formatVND = (n: number) => n.toLocaleString('vi-VN') + 'đ';
